import APIHandler from '../APIHandler';
import { API, Timeline } from '../../Common/API';

export default {
  defaultTimeline: (propertyId, payload, options) =>
    APIHandler.get(API.URL + Timeline(propertyId), payload, options),
  updateTimeline: (propertyId, payload, options) =>
    APIHandler.put(API.URL + Timeline(propertyId), payload, options)
};
